<script>
  import { createEventDispatcher } from "svelte";
  import Flatpickr from "svelte-flatpickr";
  import { endOfDay, min, max } from "date-fns";

  export let minDate = new Date(0);
  export let maxDate = endOfDay(new Date());

  export let fromDate = minDate;
  export let toDate = maxDate;

  let dispatch = createEventDispatcher();
  let options = initOptions();

  let instance = null;

  function initOptions() {
    return {
      mode: "range",
      minDate,
      maxDate
    };
  }

  function onChange(event) {
    let dates = event.detail[0];
    if (!!dates.length && dates.length > 1) {
      let curFrom = fromDate || new Date(0);
      let curTo = toDate || new Date();
      if (
        curFrom.getTime() != dates[0].getTime() &&
        curTo.getTime() != dates[1].getTime()
      ) {
        dispatch("change", {
          from: dates[0],
          to: dates[1]
        });
      }
    }
  }

  function onReady(event) {
    if (!instance) instance = event.detail[2];
    updateDisplayedDate();
  }

  $: {
    options = initOptions();
    updateDisplayedDate();
  }

  function updateDisplayedDate() {
    let from = fromDate || minDate || new Date(0);
    let to = toDate || maxDate || new Date();
    if (!!instance) {
      instance.setDate([fromDate, toDate], true);
    }
  }
</script>

<section class="app-date-range">
  <span>Showing data from</span>
  <Flatpickr {options} on:change={onChange} on:ready={onReady} />
</section>
